import { Suspense, useEffect } from 'react';
import { createBrowserRouter, RouterProvider as RouterProviderLib } from 'react-router-dom';
import { LK } from '@/pages/LK';
import { MainPage } from '@/pages/MainPage';
import { AuthPage } from '@/pages/AuthPage';
import { UserProfile } from '@/pages/UserProfile';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { PageLoader } from '@/shared/ui/PageLoader';
import { useClickstreamParams } from '@/entities/ClickStream';
import { MainLayout } from '../../../layouts/MainLayout.tsx';

export const router = createBrowserRouter(
    [
        {
            path: '/',
            element: <MainLayout />,
            children: [{ index: true, element: <MainPage /> }],
        },
        { path: '/auth', element: <AuthPage /> },
        { path: '/lk', element: <LK /> },
        { path: '/lk/profile', element: <UserProfile /> },
        { path: '*', element: <NotFoundPage /> },
    ],
    { basename: '/m2/' }
);

const RouterProvider = () => {
    const { mutate: getClickstreamParams } = useClickstreamParams();

    useEffect(() => {
        getClickstreamParams();
    }, []);

    return (
        <Suspense fallback={<PageLoader />}>
            <RouterProviderLib router={router} />
        </Suspense>
    );
};

export default RouterProvider;
